import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { Appointment } from "../../@data";

interface CancelAppointmentButtonProps {
  appointment: Appointment;
  onCancel: (appointment: Appointment) => void;
  disabled?: boolean;
}

const CancelAppointmentButton: React.FC<CancelAppointmentButtonProps> = ({
  appointment,
  onCancel,
  disabled = false,
}) => {
  const handleClick = () => {
    onCancel(appointment);
  };

  return (
    <Tooltip title="Cancelar agendamento">
      <IconButton
        size="large"
        color="error"
        onClick={handleClick}
        disabled={disabled}
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 1)",
          },
        }}
      >
        <CancelIcon />
      </IconButton>
    </Tooltip>
  );
};

export default CancelAppointmentButton;
